var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7285_8580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.58333 13.3333C7.58333 13.5101 7.65357 13.6797 7.7786 13.8047C7.90362 13.9298 8.07319 14 8.25 14C8.42681 14 8.59638 13.9298 8.7214 13.8047C8.84643 13.6797 8.91667 13.5101 8.91667 13.3333V8.66667H13.5833C13.7601 8.66667 13.9297 8.59643 14.0547 8.4714C14.1798 8.34638 14.25 8.17681 14.25 8C14.25 7.82319 14.1798 7.65362 14.0547 7.5286C13.9297 7.40357 13.7601 7.33333 13.5833 7.33333H8.91667V2.66667C8.91667 2.48986 8.84643 2.32029 8.7214 2.19526C8.59638 2.07024 8.42681 2 8.25 2C8.07319 2 7.90362 2.07024 7.7786 2.19526C7.65357 2.32029 7.58333 2.48986 7.58333 2.66667V7.33333H2.91667C2.73986 7.33333 2.57029 7.40357 2.44526 7.5286C2.32024 7.65362 2.25 7.82319 2.25 8C2.25 8.17681 2.32024 8.34638 2.44526 8.4714C2.57029 8.59643 2.73986 8.66667 2.91667 8.66667H7.58333V13.3333Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7285_8580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.17963bfadae754691f1066b7429f26a2.svg";
export { ForwardRef as ReactComponent };